export default "__VITE_ASSET__960f3e44__"